import { useRef, useState } from "react";
import { toast } from "sonner";
import { Mic, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

export const VoiceInput = ({ onParsed }) => {
  const [state, setState] = useState("idle");
  const [heard, setHeard] = useState("");
  const recRef = useRef(null);

  const parse = async (text) => {
    setState("parsing");
    try {
      const { data } = await api.post("/rides/parse-voice", { text });
      if (!Object.keys(data).length) throw new Error();
      onParsed(data);
      toast.success("Corsa compilata dalla voce: controlla e conferma");
    } catch (e) {
      toast.error(apiError(e, "Non ho capito la corsa, riprova"));
    } finally {
      setState("idle");
    }
  };

  const start = () => {
    if (!Recognition) return toast.error("Dettatura non supportata da questo browser (usa Chrome o Safari)");
    if (state === "listening") return recRef.current?.stop();
    const rec = new Recognition();
    rec.lang = "it-IT";
    rec.interimResults = false;
    rec.onresult = (e) => {
      const text = e.results[0][0].transcript;
      setHeard(text);
      parse(text);
    };
    rec.onerror = () => setState("idle");
    rec.onend = () => setState((s) => (s === "listening" ? "idle" : s));
    recRef.current = rec;
    setState("listening");
    rec.start();
  };

  return (
    <div className="flex flex-col gap-2">
      <button type="button" data-testid="voice-input-button" onClick={start} disabled={state === "parsing"} className={`ff-btn-secondary w-full text-base uppercase ${state === "listening" ? "!border-red-500 !text-red-300" : "border-[#10B981]"}`}>
        {state === "parsing" ? <Loader2 size={22} className="animate-spin" /> : <Mic size={22} />}
        {state === "listening" ? "Sto ascoltando… tocca per fermare" : state === "parsing" ? "Compilo la corsa…" : "Detta la corsa a voce"}
      </button>
      <p data-testid="voice-input-hint" className="text-xs text-[#CBD5E1] text-center">{heard ? `“${heard}”` : "Es. “Da Firenze a Milano domani ore 10, 300 euro”"}</p>
    </div>
  );
};
